module.exports = __webpack_public_path__ + "img/default_news_16_9.92a1c76f.png";